module.exports = __webpack_public_path__ + "img/ics_o_destination_active.7c66a967.svg";